import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from "element-plus";
import 'element-plus/dist/index.css'
import zhLocale from "element-plus/es/locale/lang/zh-cn";

const customapp = createApp(App).use(ElementUI, {
  locale: zhLocale
});

customapp.use(store).use(router);

customapp.mount('#app');
